module.exports = __webpack_public_path__ + "static/media/09.cdf84d8e.jpg";